export default "__VITE_ASSET__BKz72rD1__"